import { Indicator, Tooltip, UnstyledButton } from "@mantine/core";
import type { TablerIcon } from "@tabler/icons-react";
import { SIDEBAR_ACTIVE_HIGHLIGHT } from "@/components/layout/sidebarLayout.const";

export type SidebarIconRailVariant = "dark" | "light";

type SidebarIconRailLinkProps = {
  icon: TablerIcon;
  label: string;
  active?: boolean;
  disabled?: boolean;
  onClick: () => void;
  badgeCount?: number;
  variant?: SidebarIconRailVariant;
};

export function SidebarIconRailLink({
  icon: Icon,
  label,
  active = false,
  disabled = false,
  onClick,
  badgeCount,
  variant = "dark",
}: SidebarIconRailLinkProps) {
  const inactiveIconColor =
    variant === "light" ? "var(--mantine-color-gray-7)" : "rgba(255, 255, 255, 0.95)";
  const activeIconColor = "var(--mantine-color-primary-7)";
  const activeBg = variant === "light" ? "var(--mantine-color-primary-0)" : SIDEBAR_ACTIVE_HIGHLIGHT;

  return (
    <Tooltip label={label} position="right" withArrow disabled={disabled}>
      <UnstyledButton
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        aria-current={active ? "page" : undefined}
        w="100%"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 44,
          marginLeft: -8,
          marginRight: -8,
          paddingLeft: 8,
          paddingRight: 8,
          borderRadius: active ? "10px 0 0 10px" : 10,
          backgroundColor: active ? activeBg : "transparent",
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? "not-allowed" : "pointer",
          transition: "background-color 0.15s ease",
        }}
        onMouseEnter={(e) => {
          if (disabled || active) return;
          e.currentTarget.style.backgroundColor =
            variant === "light" ? "var(--mantine-color-gray-1)" : "rgba(255, 255, 255, 0.1)";
        }}
        onMouseLeave={(e) => {
          if (active) return;
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        <Indicator
          disabled={!badgeCount}
          label={badgeCount}
          size={18}
          color="red"
          offset={4}
          inline
        >
          <Icon size={22} stroke={1.8} color={active ? activeIconColor : inactiveIconColor} />
        </Indicator>
      </UnstyledButton>
    </Tooltip>
  );
}
